import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalHeaderService } from '../global-header.service';
import { ContextService } from '../context.service';
import { Highlight } from '../highlight';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-highlight',
  templateUrl: './highlight.component.html',
  styleUrls: ['./highlight.component.less']
})
export class HighlightComponent implements OnInit, OnDestroy {
  
  private subscriptions = new Subscription();

  public model : Highlight

  constructor(
    private route: ActivatedRoute,
    private contextService: ContextService,
    private headerService: GlobalHeaderService ) {
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      
      var name = this.route.snapshot.paramMap.get("name");

      var itemsSubscription = this.contextService.getHighlight(name).subscribe(data => {
        this.model = data;
        this.headerService.setHead(this.model);
      });
      
      this.subscriptions.add(itemsSubscription);
    });
    
    //this.subscriptions.add(subscription);
  }
  
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
